/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

@observer
export default class TermsComponent extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 signin">
                        <hr />
                        <h2 id="generaltermsandconditionsofsaleanddeliveryeffectivejanuary2018">
                            General Terms and Conditions of Sale and Delivery
                        </h2>
                        Effective: January 2018
                        <hr />
                        <p>
                            deliver.media <br />
                            <strong>SMP Solutions GmbH</strong> <br />
                            Platz 3 <br />
                            CH-6039 Root D4 <br />
                            Switzerland
                        </p>
                        <hr />
                        <h3 id="1ingeneral">1 IN GENERAL</h3>
                        <h4 id="11scopeofapplication">1.1 Scope of Application</h4>
                        <p>
                            The general terms of sale and delivery are valid for sales by
                            SMP Solutions GmbH (“the Seller”). They apply to all purchase
                            contracts entered into with the customers (“the Purchaser”) as well as
                            offers. Deviations from the provisions of the general terms and
                            conditions of sale and delivery must be in writing. Conflicting and
                            deviating terms of the Purchaser are not accepted and have no effect
                            whatsoever. <br />
                            These general terms of sale and delivery replace all the Seller's terms
                            and conditions of sale and delivery hitherto. The partial invalidity of
                            clauses of these terms of sales and delivery do not entail the
                            invalidity of the terms as a whole.
                        </p>
                        <h4 id="12offerandprice">1.2 Offer and Price</h4>
                        <p>
                            In the absence of written agreements, prices offered are in Swiss
                            Francs, ex works, VAT not included. The costs for packing, shipping,
                            insurance, as well as fees for approvals, certificates, statutory taxes
                            and all other applicable shipping costs are not included and will be
                            billed as separate line item. The prices stated in the Seller's written
                            offers are valid for the time period stated therein. If no time period
                            is specified, the offer will be valid for 30 days from the date of the
                            offer. For orders received after the offer period has expired, the
                            Seller reserves the right to make price or other adjustments. <br />
                            Drawings, plans and descriptions contained in offers, are solely for
                            information purposes. Only attachments to the order confirmation of the
                            Seller will become part of the contract.
                        </p>
                        <h4 id="13orderconfirmations">1.3 Order Confirmations</h4>
                        <p>
                            A legal and binding contract will only be effective upon receipt of a
                            written order confirmation by the Seller. Orders confirmed by the Seller
                            can only be postponed, changed or cancelled by the Purchaser if written
                            consent is obtained by both parties and provided that the Purchaser is
                            responsible for all costs and losses resulting from such change,
                            cancellation or postponement.
                        </p>
                        <h3 id="2conditionsofdelivery">2 CONDITIONS OF DELIVERY</h3>
                        <h4 id="21deliveryscheduling">2.1 Delivery Scheduling</h4>
                        <p>
                            The Seller will undertake best efforts to adhere to the confirmed
                            delivery schedule. However, the delivery times the Seller specified are
                            target times and not binding promises, unless explicitly declared by the
                            Seller. <br />
                            Should the documents and authorizations required from the Purchaser in
                            advance, as well as contractual prepayments not be made available to the
                            Seller on the date agreed upon, the delivery will be automatically
                            postponed. <br />
                            In such case the Purchaser is obliged to remunerate the Seller for any
                            damages and additional costs.
                        </p>
                        <p>
                            If the Seller is responsible for the delay, the Purchaser can withdraw
                            from the contract after the additional period of time fixed by the
                            Purchaser in writing has expired, subject to the provisions of Section
                            2.3. <br />
                            The Seller is liable for Purchaser's claims originated from delay on
                            delivery only if gross negligence can be proven. The burden of proof is
                            on the Purchaser. Any liability for indirect damages is excluded.
                        </p>
                        <p>
                            If the Purchaser does not accept the goods at the point of time agreed
                            upon, the Seller has the right to store the goods at the Purchaser's own
                            risk and cost. Such failure of acceptance does not entitle the Purchaser
                            to withdraw from the contract or to withhold payments.
                        </p>
                        <h4 id="22partialdelivery">2.2 Partial Delivery</h4>
                        <p>
                            Partial deliveries are acceptable to the Seller and the Purchaser only
                            as stipulated in written agreements at time of order confirmation from
                            the Seller. Associated costs related to partial deliveries (i.e.
                            warehousing) will be billed to the Purchaser.
                        </p>
                        <h4 id="23forcemajeure">2.3 Force Majeure</h4>
                        <p>
                            In all cases of force majeure, specially due to unexpected events in the
                            manufacturing or in sales resulting from late delivery of raw materials
                            or semi- finished products, boycott, lock-out or work rebellions, namely
                            strikes, either in its own facilities, or by suppliers or by
                            transportation companies, as well as events of war or mobilization, the
                            Seller is not obligated to observe the delivery schedule, and the
                            Purchaser will not have the right to cancel the contract and/or claim
                            damages.
                        </p>
                        <h3 id="3payment">3 PAYMENT</h3>
                        <h4 id="31requestsforpayment">3.1 Requests for Payment</h4>
                        <p>
                            The Seller's invoices, unless otherwise agreed in writing, are due 30
                            days from the billing date. See Section 4 for retention of title.
                        </p>
                        <h4 id="32latepayment">3.2 Late Payment</h4>
                        <p>
                            The non-observance of the payment requirement gives the Seller the right
                            to suspend subsequent deliveries, including those for warranty
                            requirements, to repossess the goods already delivered by the Seller, to
                            demand compensation for the corresponding damages, as well as to
                            withdraw from the contract. After the payment period has expired and
                            without further notice the Purchaser has to pay an interest on late
                            payment as defined by Swiss law. The Purchaser does not have the right
                            to stop payment due to complaints or to offset payments against
                            counterclaims.
                        </p>
                        <h3 id="4retentionoftitle">4 RETENTION OF TITLE</h3>
                        <p>
                            Until payment of the total amount of the purchase price, the Seller has
                            the right to register retention of title for the goods delivered.
                        </p>
                        <h3 id="5warranty">5 WARRANTY</h3>
                        <h4 id="51shippingandinsurance">5.1 Shipping and Insurance</h4>
                        <p>
                            When no specific written instructions are established between the Seller
                            and the Purchaser, the Seller will select the form of shipment which is
                            most advantageous, at the Purchaser's cost and risk. <br />
                            The Purchaser is responsible for the insurance of the transportation
                            risk. Should the Seller make insurance arrangements, such arrangements
                            will be made by order of and for account of the Purchaser. <br />
                            Acceptance of deliveries with damages or losses caused by transportation
                            must be made with reservation, and the transportation company must be
                            notified by the Purchaser in writing immediately. The report of damages
                            should be sent to the corresponding insurance company with copy to the
                            Seller.
                        </p>
                        <h4 id="52noticeofdefectscustomerscomplaints">
                            5.2 Notice of Defects, Customer's Complaints
                        </h4>
                        <p>
                            The Purchaser must examine the delivered goods immediately. Notice of
                            defects for quantity, quality or workmanship must be notified in writing
                            to the Seller within 8 days of delivery of the goods. Hidden damages
                            must be notified in writing immediately upon discovery. The delivery
                            will be deemed free from defects by failure of the Purchaser to make
                            such notification.
                        </p>
                        <h4 id="53warrantyprovisions">5.3 Warranty Provisions</h4>
                        <p>
                            The warranty period for the Seller’s products is 12 months from delivery
                            provided there are no written agreements to the contrary. The Seller
                            guarantees during the warranty period that the product delivered is free
                            from material and/or manufacturing defects. Any further warranty,
                            including fitness of the product for the purpose intended by the
                            Purchases is excluded. In case of material and/or manufacturing defects,
                            the Seller will repair the delivered product free of charge within the
                            warranty period. The warranty does not cover wear and tear, components
                            damaged mechanically, and defects due to inappropriate use, poor
                            servicing or inappropriate repairing.
                        </p>
                        <p>
                            All other claims for breach of warranty are excluded, in particular (but
                            not limited to) claims for damages. For replaced or repaired components
                            a warranty of 6 months in accordance with Section 5.3., paragraph 2 is
                            granted. <br />
                            The above warranties expire automatically as soon as the Purchaser or a
                            third person modifies the product (e.g. inappropriate repairing, repair
                            attempts or any other modifications).
                        </p>
                        <h4 id="54returns">5.4 Returns</h4>
                        <p>
                            Returns not authorized in writing by the Seller will not be accepted and
                            will be returned at Purchaser's cost. If a return is requested by the
                            Seller (e.g. to repair a product), the return delivery of the goods
                            shall be prepaid and shall be according to the shipping
                            instructions provided by the Seller.
                        </p>
                        <h4 id="55liability">5.5 Liability</h4>
                        <p>
                            The Seller is not liable either for the losses or the damages caused
                            either by the use or deficiency of the Seller's products. <br />
                            The Seller's liability for defective goods is limited to the removal of
                            the defect in accordance with the provisions described in Section 5.3.{' '}
                            <br />
                            Should the Seller be held liable to third parties due to damages caused
                            by Purchaser's faulty behavior, the Purchaser shall be obligated to
                            indemnify and hold harmless the Seller.
                        </p>
                        <h3 id="6technicalmodifications">6 TECHNICAL MODIFICATIONS</h3>
                        <p>
                            The Seller reserves the right, prior to delivery, to carry out
                            electrical or mechanical improvements. However, the Seller is not
                            obligated to modify products previously delivered or to deliver new
                            products according to prior specifications.
                        </p>
                        <h3 id="7intellectualproperty">7 INTELLECTUAL PROPERTY</h3>
                        <p>
                            The Purchaser, through acquisition of the Seller's products, does not
                            acquire any right on the Seller's intellectual property, such as patent,
                            trademark, model and design rights, or copyrights. Software, as well as
                            documentation delivered to be used for the products manufactured by the
                            Seller, remains the Seller’s exclusive property. The Purchaser has the
                            un-assignable and nonexclusive right to use the software and the
                            products delivered by the Seller.
                        </p>
                        <h3 id="8confidentiality">8 CONFIDENTIALITY</h3>
                        <p>
                            The Purchaser shall maintain strict confidentiality in respect of all
                            technical specifications of products or knowledge about products and
                            shall respect the Seller's business secrets. The documents delivered by
                            the Seller and the software provided for use must not be copied or made
                            accessible to third parties but may only be used to fulfill the purpose
                            of the contract. The Purchaser shall impose this obligation also on its
                            company executives and employees as well as on any third parties it may
                            lawfully consult. Any infringement of this obligation will entitle the
                            Seller to claim compensation and to suspend the performance of the
                            Seller's obligations.
                        </p>
                        <h3 id="9governinglawandjurisdiction">9 GOVERNING LAW AND JURISDICTION</h3>
                        <p>
                            All legal relationships between the Seller and the Purchaser, in
                            particular (but not limited to) any contracts concluded between the
                            Seller and the Purchaser shall be governed by Swiss law excluding the
                            provisions of the Vienna Convention on the International Sale of Goods
                            of April 11, 1980. Lucerne is the exclusive jurisdiction for all disputes
                            arising out of, or in connection with, the individual purchase contract.
                            However, the Seller is entitled to sue the Purchaser at any other
                            competent court.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
